(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alfheim-scalp-ritual"] && !Shopify.designMode) return;
  try {
    
;(() => {
  if (customElements.get('alfheim-scalp-ritual')) return;

  class AlfheimScalpRitual extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._cleanup = [];
      this._panels = [...this.querySelectorAll('[data-ritual-panel]')];
      this._tabs = [...this.querySelectorAll('[data-ritual-tab]')];
      this._steps = [];
      this._tabs.forEach(tab => {
        const panel = this._panels.find(panel => panel.id === tab.getAttribute('aria-controls'));
        if (!panel) {
          tab.hidden = true;
          tab.tabIndex = -1;
          tab.classList.remove('is-active');
          tab.setAttribute('aria-selected', 'false');
        } else if (!tab.hidden && !tab.disabled) {
          this._steps.push({tab, panel});
        } else {
          tab.tabIndex = -1;
          tab.classList.remove('is-active');
          tab.setAttribute('aria-selected', 'false');
        }
      });
      const initial = Number.parseInt(this.dataset.initialStep, 10);
      const requested = Number.isInteger(this._index) ? this._index : (Number.isFinite(initial) ? initial : 5) - 1;
      this._index = this._steps.length ? Math.max(0, Math.min(this._steps.length - 1, requested)) : -1;
      this._media = matchMedia('(max-width: 749px)');
      this._touchArea = this.querySelector('[data-ritual-panels]');
      this._live = this.querySelector('[data-ritual-live]');
      this._tagline = this.querySelector('[data-ritual-current-tagline]');
      this._previous = this.querySelector('[data-ritual-prev]');
      this._next = this.querySelector('[data-ritual-next]');
      this._gesture = null;
      this._swipe = null;

      this._listen(this, 'click', event => {
        const button = event.target.closest?.('[data-ritual-tab], [data-ritual-prev], [data-ritual-next]');
        if (!button || !this.contains(button) || button.disabled || button.hidden) return;
        const index = this._steps.findIndex(step => step.tab === button);
        if (index >= 0) {
          event.preventDefault();
          this._select(index, true);
        } else if (button === this._previous || button === this._next) {
          event.preventDefault();
          this._select(this._index + (button === this._next ? 1 : -1), true);
        }
      });
      this._listen(this, 'keydown', event => {
        const index = this._steps.findIndex(step => step.tab === event.target);
        if (index < 0 || event.altKey || event.ctrlKey || event.metaKey) return;
        let next;
        if (event.key === 'ArrowLeft') next = index - 1;
        else if (event.key === 'ArrowRight') next = index + 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this._steps.length - 1;
        else return;
        event.preventDefault();
        this._select(next, true);
        this._steps[this._index]?.tab.focus();
      });

      this._listen(this, 'shopify:block:select', event => {
        const index = this._steps.findIndex(step => step.panel.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this._select(index, false);
      });

      const change = () => {
        this._gesture = null;
        this._swipe = null;
        this._render();
      };
      if (this._media.addEventListener) {
        this._media.addEventListener('change', change);
        this._cleanup.push(() => this._media.removeEventListener('change', change));
      } else {
        this._media.addListener(change);
        this._cleanup.push(() => this._media.removeListener(change));
      }

      if (this._touchArea) {
        this._listen(this._touchArea, 'pointerdown', event => {
          this._swipe = null;
          this._gesture = null;
          if (!this._media.matches || this._steps.length < 2 || event.isPrimary === false || !event.pointerType || event.pointerType === 'mouse' || (event.button !== undefined && event.button !== 0)) return;
          this._gesture = {id: event.pointerId, type: event.pointerType, x: event.clientX, y: event.clientY, horizontal: false, vertical: false};
        });
        this._listen(this._touchArea, 'pointermove', event => {
          const gesture = this._gesture;
          if (!gesture || event.pointerId !== gesture.id) return;
          const x = Math.abs(event.clientX - gesture.x);
          const y = Math.abs(event.clientY - gesture.y);
          if (!gesture.horizontal && !gesture.vertical) {
            if (y >= 10 && y > x * 1.2) gesture.vertical = true;
            else if (x >= 10 && x > y * 1.2) gesture.horizontal = true;
          }
          if (gesture.horizontal && !gesture.vertical && event.cancelable) event.preventDefault();
        }, {passive: false});
        this._listen(this._touchArea, 'pointerup', event => {
          const gesture = this._gesture;
          if (!gesture || event.pointerId !== gesture.id) return;
          this._gesture = null;
          const x = event.clientX - gesture.x;
          const y = event.clientY - gesture.y;
          if (!this._media.matches || gesture.vertical || Math.abs(x) < 40 || Math.abs(x) <= Math.abs(y) * 1.2) return;
          this._swipe = {time: Date.now(), id: gesture.id, type: gesture.type};
          this._select(this._index + (x < 0 ? 1 : -1), true);
        });
        this._listen(this._touchArea, 'pointercancel', () => {
          this._gesture = null;
          this._swipe = null;
        });
        this._listen(this._touchArea, 'click', event => {
          const swipe = this._swipe;
          if (!swipe || Date.now() - swipe.time > 700 || event.detail === 0 || event.pointerType === 'mouse') return;
          if (event.pointerType && event.pointerType !== swipe.type) return;
          if (event.pointerId !== undefined && event.pointerId >= 0 && event.pointerId !== swipe.id) return;
          this._swipe = null;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);
      }
      this._render();
    }

    _listen(target, name, handler, options) {
      target.addEventListener(name, handler, options);
      this._cleanup.push(() => target.removeEventListener(name, handler, options));
    }

    _select(index, announce) {
      const count = this._steps.length;
      if (!count) return;
      this._index = ((index % count) + count) % count;
      this._render();
      if (announce && this._live) {
        const step = this._steps[this._index];
        const title = step.tab.textContent.trim().replace(/\s+/g, ' ');
        const tagline = step.panel.dataset.tagline || '';
        this._live.textContent = [title, tagline].filter(Boolean).join('. ');
      }
    }

    _render() {
      const selected = this._steps[this._index];
      this._steps.forEach(step => {
        const active = step === selected;
        step.tab.classList.toggle('is-active', active);
        step.tab.setAttribute('aria-selected', String(active));
        step.tab.tabIndex = active && !step.tab.hidden ? 0 : -1;
      });
      this._panels.forEach(panel => {
        const active = panel === selected?.panel;
        panel.toggleAttribute('data-active', active);
        panel.classList.toggle('is-active', active);
        panel.hidden = this._media.matches && !active;
      });
      if (this._tagline) this._tagline.textContent = selected?.panel.dataset.tagline || '';
      if (this._previous) this._previous.disabled = this._steps.length < 2;
      if (this._next) this._next.disabled = this._steps.length < 2;
    }

    disconnectedCallback() {
      this._cleanup?.forEach(remove => remove());
      this._cleanup = [];
      this._gesture = null;
      this._swipe = null;
      this._connected = false;
    }
  }

  customElements.define('alfheim-scalp-ritual', AlfheimScalpRitual);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  let drag = null;

  document.addEventListener('slide-stop', (event) => {
    const list = event.target;
    if (!list.matches('.pairs-carousel__list')) return;
    requestAnimationFrame(() => {
      const controls = document.getElementById(list.dataset.controls);
      if (!controls) return;
      const offset = Math.abs(list.scrollLeft);
      controls.querySelector('.slider-button--prev').disabled = offset <= 1;
      controls.querySelector('.slider-button--next').disabled = offset >= list.scrollWidth - list.clientWidth - 1;
    });
  }, true);

  document.addEventListener('mousedown', (event) => {
    drag = null;
    if (event.button !== 0) return;
    const list = event.target.closest('.pairs-carousel__list');
    if (!list || event.target.closest('button, .pairs-carousel__quick-add, quick-view')) return;
    drag = { list, startX: event.clientX, startY: event.clientY, moved: false };
  }, true);

  document.addEventListener('mousemove', (event) => {
    if (!drag) return;
    const deltaX = Math.abs(event.clientX - drag.startX);
    const deltaY = Math.abs(event.clientY - drag.startY);
    if (deltaX > 8 && deltaX > deltaY) drag.moved = true;
  }, true);

  document.addEventListener('pointercancel', () => { drag = null; }, true);

  document.addEventListener('click', (event) => {
    const currentDrag = drag;
    drag = null;
    if (!currentDrag || !currentDrag.moved || event.detail === 0) return;
    const link = event.target.closest('a[href]');
    if (!link || !currentDrag.list.contains(link)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();

(() => {
  if (customElements.get('alfheim-sticky-purchase')) return;

  customElements.define('alfheim-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.mainForm = document.getElementById(this.dataset.mainFormId);
      this.mainProductForm = this.mainForm?.closest('product-form');
      this.mainButton = this.mainProductForm?.querySelector('[type="submit"]');
      this.button = this.querySelector('[data-alfheim-sticky-submit]');
      this.label = this.querySelector('[data-alfheim-sticky-label]');
      if (!this.mainForm || !this.mainButton || !this.button || !this.productInfo) {
        if (this.button) this.button.disabled = true;
        return;
      }

      const stickyCart = this.closest('.product-sticky-cart');
      this.priceContainer = stickyCart.querySelector('[data-alfheim-sticky-price-container]');
      try {
        this.prices = JSON.parse(stickyCart.querySelector('[data-alfheim-sticky-prices]').textContent);
      } catch {
        this.prices = {};
      }
      this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
      this.errorText = this.querySelector('.product-form__error-message');
      this.mainErrorWrapper = this.mainProductForm.querySelector('.product-form__error-message-wrapper');
      this.mainErrorText = this.mainProductForm.querySelector('.product-form__error-message');
      this.primaryQuantity = this.productInfo.querySelector('.quantity__input-primary');
      this.stickyQuantity = this.querySelector('.quantity__input-sticky');
      this.configureQuantity();
      if (this.primaryQuantity && this.stickyQuantity) this.stickyQuantity.value = this.primaryQuantity.value;

      this.onProductInput = (event) => {
        this.handleQuantityChange(event);
        this.scheduleSync();
      };
      this.onVariantChange = (event) => {
        const sectionId = this.productInfo.dataset.originalSection || this.productInfo.dataset.section;
        if (event.detail?.sectionId === sectionId) this.scheduleSync();
      };
      this.productInfo.addEventListener('input', this.onProductInput);
      this.productInfo.addEventListener('change', this.onProductInput);
      document.addEventListener('variant:change', this.onVariantChange);
      this.onSellingPlanChange = this.handleSellingPlanChange.bind(this);
      document.addEventListener('sealsubs:selling_plan_changed', this.onSellingPlanChange);
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.observer.observe(this.mainProductForm, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'value']
      });
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.productInfo?.removeEventListener('input', this.onProductInput);
      this.productInfo?.removeEventListener('change', this.onProductInput);
      document.removeEventListener('variant:change', this.onVariantChange);
      document.removeEventListener('sealsubs:selling_plan_changed', this.onSellingPlanChange);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    handleSellingPlanChange(event) {
      const element = event.detail?.element;
      if (element instanceof Element && this.mainProductForm.contains(element)) this.scheduleSync();
    }

    configureQuantity() {
      if (!this.stickyQuantity) return;
      if (this.primaryQuantity) this.stickyQuantity.removeAttribute('form');
      else this.stickyQuantity.setAttribute('form', this.mainForm.getAttribute('id'));
    }

    handleQuantityChange(event) {
      if (!this.primaryQuantity || !this.stickyQuantity) return;
      if (event.target === this.stickyQuantity && this.primaryQuantity.value !== this.stickyQuantity.value) {
        this.primaryQuantity.value = this.stickyQuantity.value;
        this.primaryQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (event.target === this.primaryQuantity) {
        this.stickyQuantity.value = this.primaryQuantity.value;
      }
    }

    scheduleSync() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.isConnected) this.sync();
      });
    }

    sync() {
      const loading = this.mainButton.classList.contains('loading');
      const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true' || loading;
      this.button.disabled = disabled;
      this.button.classList.toggle('loading', loading);
      if (disabled) this.button.setAttribute('aria-disabled', 'true');
      else this.button.removeAttribute('aria-disabled');
      const sourceLabel = this.mainButton.querySelector('.sold-out-message:not(.hidden)') || this.mainButton.querySelector('span') || this.mainButton;
      const label = sourceLabel.textContent.trim();
      if (this.label.textContent !== label) this.label.textContent = label;

      if (this.errorWrapper) {
        const message = this.mainErrorText?.textContent || '';
        this.errorWrapper.hidden = !this.mainErrorWrapper || this.mainErrorWrapper.hidden || !message;
        if (this.errorText && this.errorText.textContent !== message) this.errorText.textContent = message;
      }

      const fields = new FormData(this.mainForm);
      const variant = this.prices[String(fields.get('id'))];
      const plan = fields.get('selling_plan');
      const price = plan ? variant?.plans?.[String(plan)] : variant?.price;
      const output = this.priceContainer?.querySelector('[data-alfheim-sticky-price]');
      if (this.priceContainer) this.priceContainer.hidden = typeof price !== 'string';
      if (output && typeof price === 'string' && output.textContent !== price) output.textContent = price;
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
